import Login from "./views/pages/login/Login";
import Dashboard from "./views/dashboard/Dashboard";
import Details from "./views/details/Details";
import VerifyCode from "./views/pages/login/VerifyCode";

export const allRoutes = [
  {path: '/login', exact: true, name: 'Login', component: Login},
  {path: '/verifyCode', name: 'VerifyCode', component: VerifyCode},
  {path: '/dashboard', name: 'Dashboard', component: Dashboard},
  {path: '/details', name: 'Details', component: Details}
];

export const routes = [
  {path: '/dashboard', name: 'Dashboard', component: Dashboard},
  {path: '/details', name: 'Details', component: Details}
];
